import { PayloadAction } from 'tabs/topQuestions/types/GenericTypes'
import { FetchClusteringStatusResponse, StartClusteringResponse } from 'tabs/topQuestions/types/ApiResponses'
import { QuestionClusteringConfiguration, UpdateClusteringStatusPayload } from 'tabs/topQuestions/types/InternalTypes'
import { UPGRADE_TRAIN_CONFIGURATION } from 'tabs/topQuestions/lib/top_questions/topQuestionsConstnats'

export const FETCH_CLUSTERING_STATUS_REQUEST = 'clusteringConfiguration/FETCH_CLUSTERING_STATUS_REQUEST'
export const FETCH_CLUSTERING_STATUS_SUCCESS = 'clusteringConfiguration/FETCH_CLUSTERING_STATUS_SUCCESS'
export const FETCH_CLUSTERING_STATUS_FAILED = 'clusteringConfiguration/FETCH_CLUSTERING_STATUS_FAILED'
export const UPDATE_ACTIVE_CLUSTERING_EXECUTION_ID = 'clusteringConfiguration/UPDATE_ACTIVE_CLUSTERING_EXECUTION_ID'
export const CLEAR_SELECTED_EXECUTION_ID = 'clusteringConfiguration/clearSelectedExecutionId'

export type UpgradeTrainConfiguration = PayloadAction<typeof UPGRADE_TRAIN_CONFIGURATION, Partial<QuestionClusteringConfiguration>>
export type FetchClusteringStatusRequest = PayloadAction<typeof FETCH_CLUSTERING_STATUS_REQUEST, undefined>
export type FetchClusteringStatusSuccess = PayloadAction<typeof FETCH_CLUSTERING_STATUS_SUCCESS, FetchClusteringStatusResponse>
export type FetchClusteringStatusFailed = PayloadAction<typeof FETCH_CLUSTERING_STATUS_FAILED, string>
export type UpdateActiveClusteringExecutionId = PayloadAction<typeof UPDATE_ACTIVE_CLUSTERING_EXECUTION_ID, string>
export type ClearSelectedExecutionId = PayloadAction<typeof CLEAR_SELECTED_EXECUTION_ID, undefined>

export type ClusteringConfigurationAction = UpgradeTrainConfiguration
  | FetchClusteringStatusRequest
  | FetchClusteringStatusSuccess
  | FetchClusteringStatusFailed
  | UpdateActiveClusteringExecutionId
  | ClearSelectedExecutionId
